import {ReduxList} from "app/types/app-types";
import {ApiRequest} from "app/types/api-types";

export type State = ReduxList<any>

export const GET_ALT_TEMPLATES: ApiRequest = {
    CREATE: "GET_ALT_TEMPLATES_CREATE",
    STARTED: "GET_ALT_TEMPLATES_STARTED",
    SUCCESS: "GET_ALT_TEMPLATES_SUCCESS",
    ERROR: "GET_ALT_TEMPLATES_ERROR",
}

export const GET_ALT_TEMPLATES_LEVELS: ApiRequest = {
    CREATE: "GET_ALT_TEMPLATES_LEVELS_CREATE",
    STARTED: "GET_ALT_TEMPLATES_LEVELS_STARTED",
    SUCCESS: "GET_ALT_TEMPLATES_LEVELS_SUCCESS",
    ERROR: "GET_ALT_TEMPLATES_LEVELS_ERROR",
}